module.exports = __webpack_public_path__ + "img/20.e9a7441f.jpg";